<template>
    <div no-body id="print">
        <modal :size="'xl'" :show.sync="modals.addNote">
            <h6 slot="header" class="modal-title">Note ({{modals.note_title}})</h6>
            <form class="form-group">
                <base-input>
                    <textarea resize="none" class="form-control" name="" placeholder="Add note" id="note-description" cols="20" rows="3" v-model="modals.note"></textarea>
                </base-input>
            </form>
            <template slot="footer">
                <base-button type="primary" @click.prevent="updateNote()">Create / Save</base-button>
                <base-button type="link" class="ml-auto" @click.self="closeModal()">Close</base-button>
            </template>
        </modal>
        <b-row class="mx-2">
            <b-col>
                <card> 
                    <div slot="header">
                        <b-row >
                            <b-col cols="6">
                                <h1 class="mb-0">Cash Flow Statement</h1>
                            </b-col>
                            <b-col cols="6" class="text-right">
                                <base-button v-show="this.$route.params.token_kyc" type="primary" icon size="sm" @click="sendKYCToCustomer()">
                                    <span class="btn-inner--text">Send KYC To Customer</span>
                                </base-button>
                                <base-button type="primary" icon size="sm" v-b-toggle.collapse-3>
                                    <span class="btn-inner--icon"><i class="fas fa-caret-down"></i></span>
                                </base-button>
                            </b-col>
                        </b-row>
                    </div>
                    <!-- Card body -->
                    <b-collapse id=collapse-3 visible class="mx-6">
                        <div>
                            <h5 class="text-danger"> Note : <br>
                                <i>
                                    1. The blue color value indicated the value filled by customer.
                                </i>
                                <br>
                                <i>
                                    2. The gray color value indicated the value auto calculated by system.
                                </i>
                                <br>
                                <i>
                                    3. If the monthly column is being filled up, the annual value will be auto calculated; Vice versa.
                                </i>
                                <br>
                                <i>
                                    4. Advisory can only edit the column filled up by customer, if monthly column is filled up, advisory can only update the monthly column.
                                </i>
                                <br>
                                <i v-if="inputGrossIncome"><b>
                                    5. You have manually input the gross income for this customer, the auto calculated gross income should be RM {{autoGrossIncome.admin_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}
                                </b></i>
                            </h5>
                            <br> 
                            <h2>{{customers.customer_name}}</h2>
                            <table style="margin-bottom:20px">
                                <tr class="text-white">
                                    <th></th>
                                    <th style="width:5%">Note</th>
                                    <th colspan="2">Customer Answer (RM)</th>
                                    <th colspan="2">Advisory Answer (RM)</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>Yearly</td>
                                    <td>Monthly</td>
                                    <td style="width:50px">Yearly</td>
                                    <td style="width:50px">Monthly</td>
                                </tr>
                                <!-- cash infow -->
                                <template>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td colspan="6"><b>Cash Inflow - from DSR</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="6"><b>Cash Inflow</b></td>
                                    </tr>
                                    <tr v-for="cashIncome in cashIncomes.plus_info" :key="'dsr_'+cashIncome.customer_income_id">
                                        <td class="pl-4">
                                            {{cashIncome.income_type_title}}
                                        </td>
                                        <td v-if="cashIncome.income_type_title != 'Rental Income'">
                                            <base-button type="primary" icon size="sm" @click.prevent="openModal('customer_income', cashIncome.customer_income_id, cashIncome.income_type_title)">
                                                <span class="fa fa-plus"></span>
                                                <span class="btn-inner--text">Note</span>
                                            </base-button>
                                        </td>
                                        <td v-else></td>
                                        <td>{{cashIncome.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{cashIncome.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray" v-if="incomeAdminValue.plus_info[cashIncome.customer_income_id]">{{incomeAdminValue.plus_info[cashIncome.customer_income_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td><el-input type="number" min="0" size="small" id="admin-value" v-model="cashIncome.admin_value" v-on:input="updateAdminValue('customer_income', cashIncome.customer_income_id, cashIncome.admin_value)"/></td>
                                    </tr>
                                    <tr v-if="cashIncomes.gross_income">
                                        <td class="pl-4">Gross Income</td>
                                        <td></td>
                                        <td>{{cashIncomes.gross_income.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{cashIncomes.gross_income.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray">{{incomeAdminValue.gross_income.admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td>
                                            <el-input type="number" min="0" size="small" id="admin-value" v-model="incomeAdminValue.gross_income.admin_month" 
                                            @input="manualUpdateGrossIncomeAdminValue(cashIncomes.gross_income.customer_income_id,incomeAdminValue.gross_income.admin_month)" 
                                            :v-on:change="autoUpdateGrossIncomeAdminValue(cashIncomes.gross_income.customer_income_id,incomeAdminValue.gross_income.admin_month)">
                                                <template #append v-if="inputGrossIncome">
                                                    <base-button type="primary" icon size="sm" @click.prevent="resetGrossIncomeAdminValue()">
                                                        <span class="btn-inner--text">Reset</span>
                                                    </base-button>
                                                </template>
                                            </el-input>
                                        </td>
                                    </tr>
                                    <template>
                                        <tr v-if="cashIncomes.bonus_income">
                                            <td class="pl-4">Avg Bonus</td>
                                            <td>
                                                <base-button type="primary" icon size="sm" @click.prevent="openModal('customer_income', cashIncomes.bonus_income.customer_income_id, 'Avg Bonus')">
                                                    <span class="fa fa-plus"></span>
                                                    <span class="btn-inner--text">Note</span>
                                                </base-button>
                                            </td>
                                            <td>{{cashIncomes.bonus_income.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>{{cashIncomes.bonus_income.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td class="text-gray">{{(cashIncomes.bonus_income.admin_value * 12).toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="cashIncomes.bonus_income.admin_value" v-on:input="updateAdminValue('customer_income', cashIncomes.bonus_income.customer_income_id, cashIncomes.bonus_income.admin_value)"/>
                                            </td>
                                        </tr>
                                    </template>
                                    <!-- rental income -->
                                    <template v-if="cashIncomes.rental_income">
                                        <tr>
                                            <td class="pl-4">Rental Income
                                                <base-button type="primary" icon size="sm" v-if="cashIncomes.rental_income.rental_detail" @click.prevent="isExpand = !isExpand">
                                                    <span class="fa fa-plus"></span>
                                                </base-button>
                                            </td>
                                            <td v-if="!cashIncomes.rental_income.rental_detail">
                                                <base-button type="primary" icon size="sm" @click.prevent="openModal('customer_income', cashIncomes.rental_income.customer_income_id, 'Rental Income')">
                                                    <span class="fa fa-plus"></span>
                                                    <span class="btn-inner--text">Note</span>
                                                </base-button>
                                            </td>
                                            <td v-else></td>
                                            <td><b>{{cashIncomes.rental_income.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{cashIncomes.rental_income.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{incomeAdminValue.total_rental_income.admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td v-if="cashIncomes.rental_income.rental_detail">
                                                <b :v-on:change="updateTotalIncomeAdminValue(cashIncomes.rental_income.rental_detail[0].parent_customer_income_id, incomeAdminValue.total_rental_income.admin_month)">{{incomeAdminValue.total_rental_income.admin_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b>
                                            </td>
                                            <td v-else>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="cashIncomes.rental_income.admin_value" v-on:input="updateAdminValue('customer_income', cashIncomes.rental_income.customer_income_id, cashIncomes.rental_income.admin_value)"/>
                                            </td>
                                        </tr>
                                        <tr v-show="isExpand" v-for="rentalIncome in cashIncomes.rental_income.rental_detail" :key="'dsr_'+rentalIncome.id">
                                            <td class="pl-5">{{rentalIncome.income_type_title}}</td>
                                            <td>
                                                <base-button type="primary" icon size="sm" @click.prevent="openModal('customer_income', rentalIncome.customer_income_id, rentalIncome.income_type_title)">
                                                    <span class="fa fa-plus"></span>
                                                    <span class="btn-inner--text">Note</span>
                                                </base-button>
                                            </td>
                                            <td>{{rentalIncome.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td class="text-blue">{{rentalIncome.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td class="text-gray" v-if="incomeAdminValue.rental_detail[rentalIncome.customer_income_id]">{{incomeAdminValue.rental_detail[rentalIncome.customer_income_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td><el-input type="number" min="0" size="small" id="admin-value" v-model="rentalIncome.admin_value" v-on:input="updateAdminValue('customer_income', rentalIncome.customer_income_id, rentalIncome.admin_value)"/></td>
                                        </tr>
                                    </template>
                                    
                                    <tr v-for="cashIncome in cashIncomes.minus_info" :key="'dsr_'+cashIncome.customer_income_id">
                                        <td class="pl-4">(-) {{cashIncome.income_type_title}}</td>
                                        <td>
                                            <base-button type="primary" icon size="sm" @click.prevent="openModal('customer_income', cashIncome.customer_income_id, cashIncome.income_type_title)">
                                                <span class="fa fa-plus"></span>
                                                <span class="btn-inner--text">Note</span>
                                            </base-button>                                        
                                        </td>
                                        <td>{{cashIncome.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{cashIncome.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray" v-if="incomeAdminValue.minus_info[cashIncome.customer_income_id]">{{incomeAdminValue.minus_info[cashIncome.customer_income_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td><el-input type="number" min="0" size="small" id="admin-value" v-model="cashIncome.admin_value" v-on:input="updateAdminValue('customer_income', cashIncome.customer_income_id, cashIncome.admin_value)"/></td>
                                    </tr>
                                    <tr v-if="cashIncomes.net_income">
                                        <td><b>Total Inflow</b></td>
                                        <td></td>
                                        <template v-if="cashIncomes.net_income.customer_month < 0">
                                            <td class="text-red"><b>({{Math.abs(cashIncomes.net_income.customer_annual).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                            <td class="text-red"><b>({{Math.abs(cashIncomes.net_income.customer_month).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                        </template>
                                        <template v-else>
                                            <td><b>{{cashIncomes.net_income.customer_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{cashIncomes.net_income.customer_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </template>
                                        <template v-if="totalIncomeAdminValue.total_inflow.total_month < 0">
                                            <td class="text-red"><b>({{Math.abs(totalIncomeAdminValue.total_inflow.total_annual).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                            <td class="text-red" :v-on:change="updateTotalIncomeAdminValue(cashIncomes.net_income.customer_income_id, totalIncomeAdminValue.total_inflow.total_month)"><b>({{Math.abs(totalIncomeAdminValue.total_inflow.total_month).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                        </template>
                                        <template v-else>
                                            <td><b>{{totalIncomeAdminValue.total_inflow.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td :v-on:change="updateTotalIncomeAdminValue(cashIncomes.net_income.customer_income_id, totalIncomeAdminValue.total_inflow.total_month)"><b>{{totalIncomeAdminValue.total_inflow.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </template>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <!-- cash outflow -->
                                <template>
                                    <tr>
                                        <td colspan="6"><b>Cash Outflow</b></td>
                                    </tr>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td class="pl-4" colspan="6"><b>Fixed Commitments - from IM2U</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td class="pl-4" colspan="6"><b>Fixed Commitments</b></td>
                                    </tr>
                                    <tr v-for="fixedExpense in fixedExpenses.customer_liabilities_data" :key="'im2u_'+fixedExpense.customer_liability_id">
                                        <td class="pl-5">{{fixedExpense.loan_statue_name}}</td>
                                        <td>
                                            <base-button type="primary" icon size="sm" @click.prevent="openModal('customer_liability', fixedExpense.customer_liability_id, fixedExpense.loan_statue_name)">
                                                <span class="fa fa-plus"></span>
                                                <span class="btn-inner--text">Note</span>
                                            </base-button>                                        
                                        </td>
                                        <td>{{fixedExpense.customer_annual_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{fixedExpense.customer_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray" v-if="expenseAdminValue.fixed[fixedExpense.customer_liability_id] != undefined">{{expenseAdminValue.fixed[fixedExpense.customer_liability_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td>
                                            <el-input type="number" min="0" size="small" id="admin-value" v-model="fixedExpense.admin_month_curr_installment" v-on:input="updateFixedExpenseAdminValue(fixedExpense.customer_liability_id, fixedExpense.admin_month_curr_installment)"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pl-4"><b>Total Fixed Commitments</b></td>
                                        <td></td>
                                        <td><b>{{fixedExpenses.total.total_annual_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{fixedExpenses.total.total_month_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.fixed.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.fixed.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <template v-if="variableExpenses.customer_expenses_data">
                                        <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                            <td class="pl-4" colspan="6"><b>Variable Expenses - from KYC</b></td>
                                        </tr>
                                        <tr v-else>
                                            <td class="pl-4" colspan="6"><b>Variable Expenses</b></td>
                                        </tr>
                                        <tr v-for="variableExpense in variableExpenses.customer_expenses_data" :key="'kyc_'+variableExpense.customer_expense_id">
                                            <td class="pl-5">{{variableExpense.customer_question_column}}</td>
                                            <td>
                                                <base-button type="primary" icon size="sm" @click.prevent="openModal('customer_expense', variableExpense.customer_expense_id, variableExpense.customer_question_column)">
                                                    <span class="fa fa-plus"></span>
                                                    <span class="btn-inner--text">Note</span>
                                                </base-button>                                        
                                            </td>
                                            <template v-if="variableExpense.frequency_id == 2">
                                                <template v-if="variableExpense.customer_annual_value != null">
                                                    <td>{{variableExpense.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                                    <td class="text-blue">{{variableExpense.customer_month_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                                </template>
                                                <template v-else>
                                                    <td>-</td>
                                                    <td>-</td>
                                                </template>
                                                <template v-if="expenseAdminValue.variable[variableExpense.customer_expense_id]">
                                                    <td class="text-gray">{{expenseAdminValue.variable[variableExpense.customer_expense_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                                    <td>
                                                        <el-input type="number" min="0" size="small" id="admin-value" v-model="variableExpense.admin_month_value" v-on:input="updateAdminValue('customer_expense', variableExpense.customer_expense_id, variableExpense.admin_month_value)"></el-input>
                                                    </td>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="variableExpense.customer_annual_value != null">
                                                    <td class="text-blue">{{variableExpense.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                                    <td>{{variableExpense.customer_month_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                                </template>
                                                <template v-else>
                                                    <td>-</td>
                                                    <td>-</td>
                                                </template>
                                                <template v-if="expenseAdminValue.variable[variableExpense.customer_expense_id]">
                                                    <td>
                                                        <el-input type="number" min="0" size="small" id="admin-value" v-model="variableExpense.admin_annual_value" v-on:input="updateAdminValue('customer_expense', variableExpense.customer_expense_id, variableExpense.admin_annual_value)"></el-input>
                                                    </td>
                                                    <td class="text-gray">{{expenseAdminValue.variable[variableExpense.customer_expense_id].admin_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                                </template>
                                            </template>
                                        </tr>
                                        <tr>
                                            <td class="pl-4"><b>Total Variable Expenses</b></td>
                                            <td></td>
                                            <template v-if="variableExpenses.total.total_customer_annual != null">
                                                <td><b>{{variableExpenses.total.total_customer_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                                <td><b>{{variableExpenses.total.total_customer_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            </template>
                                            <template v-else>
                                                <td><b>0.00</b></td>
                                                <td><b>0.00</b></td>
                                            </template>
                                            <td><b>{{totalExpenseAdminValue.variable.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{totalExpenseAdminValue.variable.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td><b>Total Outflow</b></td>
                                        <td></td>
                                        <td><b>{{(fixedExpenses.total.total_annual_curr_installment+variableExpenses.total.total_customer_annual).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{(fixedExpenses.total.total_month_curr_installment+variableExpenses.total.total_customer_month).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.total_outflow.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.total_outflow.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <tr v-if="cashIncomes.net_income">
                                    <td><b>Net Inflow/Outflow</b></td>
                                    <td></td>
                                    <template v-if="(cashIncomes.net_income.customer_month - (fixedExpenses.total.total_month_curr_installment+variableExpenses.total.total_customer_month)) < 0">
                                        <td class="text-red"><b>({{Math.abs(cashIncomes.net_income.customer_annual - (fixedExpenses.total.total_annual_curr_installment+variableExpenses.total.total_customer_annual)).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                        <td class="text-red"><b>({{Math.abs(cashIncomes.net_income.customer_month - (fixedExpenses.total.total_month_curr_installment+variableExpenses.total.total_customer_month)).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                    </template>
                                    <template v-else>
                                        <td><b>{{(cashIncomes.net_income.customer_annual - (fixedExpenses.total.total_annual_curr_installment+variableExpenses.total.total_customer_annual)).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{(cashIncomes.net_income.customer_month - (fixedExpenses.total.total_month_curr_installment+variableExpenses.total.total_customer_month)).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </template>
                                    <template v-if="totalNetFlow.total_month < 0">
                                        <td class="text-red"><b>({{Math.abs(totalNetFlow.total_annual).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                        <td class="text-red"><b>({{Math.abs(totalNetFlow.total_month).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                    </template>
                                    <template v-else>
                                        <td><b>{{totalNetFlow.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalNetFlow.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </template>
                                </tr>
                            </table>
                        </div>
                    </b-collapse>
                    <br>
                </card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import axios from 'axios'
    import {apiGatewayDomain, getHeader} from '@/assets/js/config.js'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import swal from 'sweetalert2';
    import 'sweetalert2/dist/sweetalert2.css';
    // import cashIncomesData from './cashincomes';
    // import fixedExpensesData from './fixedexpenses';
    // import variableExpensesData from './variableexpenses';
    import {getUserInfo} from '@/assets/js/config.js'
    import debounce from 'lodash.debounce';

    export default {
        mixins: [notifyFunctionMixin],
        components: {
        },
        data() {
            return {
                customers: {},
                cashIncomesData: {},
                fixedExpensesData: {
                    total: {
                        total_annual_curr_installment: 0,
                        total_month_curr_installment: 0,
                    },
                },
                variableExpensesData: {
                    total: {
                        total_customer_annual: 0,
                        total_customer_month: 0,
                    },
                },
                actualNetflowData: {
                    annual_fixed_expense: 0,
                    annual_variable_expense: 0,
                    annual_total_netflow: 0,
                },
                loginUser : getUserInfo(),
                modals: {
                    addNote: false,
                    table_name: null,
                    note_id: null,
                    note_title: null,
                    note: null,
                },
                isExpand: true,
                inputGrossIncome: false,
                autoGrossIncome: {},
                incomeAdminValue: {
                    plus_info: [],
                    gross_income: {
                        admin_month: 0,
                        admin_annual: 0,
                    },
                    bonus_income: {
                        admin_month: 0,
                        admin_annual: 0,
                    },
                    rental_detail: [],
                    total_rental_income: {
                        admin_month: 0,
                        admin_annual: 0,
                    },
                    minus_info: [],
                },
                totalIncomeAdminValue: {
                    plus_info: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    minus_info: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    total_inflow: {
                        total_month: 0,
                        total_annual: 0,
                    },
                },
                expenseAdminValue: {
                    fixed: {},
                    variable: {},
                },
                totalExpenseAdminValue: {
                    fixed: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    variable: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    total_outflow: {
                        total_month: 0,
                        total_annual: 0,
                    }
                },
                totalNetFlow: {
                    total_month: 0,
                    total_annual: 0,
                },
                componentLoaded: false,
            };
        },
        created() {
            this.getCustomerInfo();
            this.getCustomerIncomeData();
            this.getCustomerFixedExpenseData();
            this.getCustomerVariableExpenseData();
            // this.cashIncomesData = {...this.cashIncomesData};
            // this.fixedExpensesData = {...this.fixedExpensesData};
            // this.variableExpensesData = {...this.variableExpensesData};
        },
        computed:{
            fixedExpenses() {
                const {fixedExpensesData} = this
                return fixedExpensesData
            },
            variableExpenses() {
                const {variableExpensesData} = this
                return variableExpensesData
            },
            cashIncomes() {
                const {cashIncomesData} = this
                return cashIncomesData;
            }
        },
        watch: {
            fixedExpenses: {
                handler: function(val) {
                    let expenseAdminValue = {...this.expenseAdminValue}
                    let actualFixedExpenseValue = 0;
                    val.customer_liabilities_data.filter( function( data, idx ) {

                        if(data.admin_month_curr_installment>0)
                        {
                            actualFixedExpenseValue += data.admin_month_curr_installment * 12;
                        }
                        else
                        {
                            actualFixedExpenseValue += data.customer_annual_curr_installment;
                        }

                        // cannot direct update back to the json data, will cause infinite loop
                        if(isNaN(data.admin_annual_curr_installment))
                        {
                            data.admin_annual_curr_installment = 0;
                        }

                        if(isNaN(data.admin_month_curr_installment))
                        {
                            data.admin_month_curr_installment = 0;
                        }

                        expenseAdminValue.fixed = {
                            ...expenseAdminValue.fixed,
                            [data.customer_liability_id]: {
                                admin_month: parseFloat(data.admin_month_curr_installment),
                                admin_annual: parseFloat(data.admin_month_curr_installment * 12)
                            },
                        };
                    });

                    this.expenseAdminValue = expenseAdminValue;
                    this.actualNetflowData.annual_fixed_expense = actualFixedExpenseValue;

                    this.getNetFlow();
                                     
                },
                deep: true,
            },
            variableExpenses: {
                handler: function(val) {
                    let expenseAdminValue = {...this.expenseAdminValue}
                    let actualVariableExpenseValue = 0;
                    val.customer_expenses_data.filter( function( data, idx ) {
                        if(data.admin_month_value>0)
                        {
                            actualVariableExpenseValue += data.admin_month_value * 12;
                        }
                        else if(data.admin_annual_value>0)
                        {
                            actualVariableExpenseValue += parseFloat(data.admin_annual_value);
                        }
                        else
                        {
                            if(data.customer_annual_value == null)
                            {
                                actualVariableExpenseValue += 0;
                            }
                            else
                            {
                                actualVariableExpenseValue += data.customer_annual_value;
                            }
                        }

                        // cannot direct update back to the json data, will cause infinite loop
                        if(isNaN(data.admin_annual_value))
                        {
                            data.admin_annual_value = 0;
                        }

                        if(isNaN(data.admin_month_value))
                        {
                            data.admin_month_value = 0;
                        }

                        if(data.frequency_id == 2) {
                            expenseAdminValue.variable = {
                                ...expenseAdminValue.variable,
                                [data.customer_expense_id]: {
                                    admin_month: parseFloat(data.admin_month_value),
                                    admin_annual: parseFloat(data.admin_month_value * 12)
                                },
                            };
                        }
                        else
                        {
                            expenseAdminValue.variable = {
                                ...expenseAdminValue.variable,
                                [data.customer_expense_id]: {
                                    admin_month: parseFloat((data.admin_annual_value / 12).toFixed(2)),
                                    admin_annual: parseFloat(data.admin_annual_value)
                                },
                            };
                        }
                    });
                    this.expenseAdminValue = expenseAdminValue;
                    this.actualNetflowData.annual_variable_expense = actualVariableExpenseValue;

                    this.getNetFlow();
                                     
                },
                deep: true,
            },
            cashIncomes: {
                handler: function(val) {
                    let incomeAdminValue = this.incomeAdminValue;
                    let totalRentalIncome = {
                        total_month: 0,
                        total_annual: 0,
                    };
                    // console.log(this.cashIncomesData[0].Income_Info.plus_info);

                    // plus info
                    val.plus_info.filter(function(data, idx) {
                        if(isNaN(data.admin_value))
                        {
                            data.admin_value = 0;
                        }
                        // problem
                        if(data.admin_value == null)
                        {
                            data.admin_value = data.customer_value;
                        }
                        
                        incomeAdminValue.plus_info = {
                            ...incomeAdminValue.plus_info,
                            [data.customer_income_id]: {
                                admin_month: parseFloat(data.admin_value),
                                admin_annual: parseFloat(data.admin_value * 12)
                            }
                        }
                    });

                    // bonus income
                    if(isNaN(val.bonus_income.admin_value))
                    {
                        val.bonus_income.admin_value = 0;
                        incomeAdminValue.bonus_income = {
                            admin_month: parseFloat(val.bonus_income.admin_value),
                            admin_annual: parseFloat(val.bonus_income.admin_value * 12)
                        }
                    }
                    else
                    {
                        // problem
                        if(val.bonus_income.admin_value == null)
                        {
                            val.bonus_income.admin_value = val.bonus_income.customer_value;
                        }
                        incomeAdminValue.bonus_income = {
                            admin_month: parseFloat(val.bonus_income.admin_value),
                            admin_annual: parseFloat(val.bonus_income.admin_value * 12)
                        }
                    }

                    // rental income
                    if(val.rental_income.admin_value == null)
                    {
                        val.rental_income.admin_value = 0;
                    }

                    // rental detail
                    if(val.rental_income.rental_detail != undefined)
                    {
                        val.rental_income.rental_detail.filter(function(data, idx) {
                            // problem
                            if(data.admin_value == null)
                            {
                                data.admin_value = data.customer_value;
                            }
                            incomeAdminValue.rental_detail = {
                                ...incomeAdminValue.rental_detail,
                                [data.customer_income_id]: {
                                    admin_month: parseFloat(data.admin_value),
                                    admin_annual: parseFloat(data.admin_value * 12)
                                }
                            }
                            totalRentalIncome.total_month += parseFloat(data.admin_value);
                            totalRentalIncome.total_annual = totalRentalIncome.total_month * 12;
                        });
                        
                        /**
                         * Axios here to save the rental income admin value to db 
                         * not sure will cause low performance issue or not
                         */
                    }
                    else
                    {
                        totalRentalIncome.total_month = parseFloat(val.rental_income.admin_value);
                        totalRentalIncome.total_annual = parseFloat(val.rental_income.admin_value * 12);
                    }
                    // this.totalRentalIncomeAdminValue = totalRentalIncome;
                    this.incomeAdminValue.total_rental_income.admin_annual = totalRentalIncome.total_annual
                    this.incomeAdminValue.total_rental_income.admin_month = totalRentalIncome.total_month

                    // minus info
                    val.minus_info.filter(function(data, idx) {
                        if(isNaN(data.admin_value))
                        {
                            data.admin_value = 0;
                        }
                        // problem
                        if(data.admin_value == null)
                        {
                            data.admin_value = data.customer_value;
                        }
                        
                        incomeAdminValue.minus_info = {
                            ...incomeAdminValue.minus_info,
                            [data.customer_income_id]: {
                                admin_month: parseFloat(data.admin_value),
                                admin_annual: parseFloat(data.admin_value * 12)
                            }
                        }
                    });

                    // gross income
                    if(val.gross_income.admin_value != null && val.gross_income.admin_value != 0)
                    {
                        incomeAdminValue.gross_income = {
                            admin_month: parseFloat(val.gross_income.admin_value),
                            admin_annual: parseFloat(val.gross_income.admin_value * 12),
                        }
                    }
                    else
                    {
                        if(!this.inputGrossIncome)
                        {
                            incomeAdminValue.gross_income = {
                                admin_month: parseFloat(val.gross_income.customer_value),
                                admin_annual: parseFloat(val.gross_income.customer_value * 12),
                            }
                        }
                    }
                    this.incomeAdminValue = incomeAdminValue;
                    this.getNetFlow();
                },
                deep: true,
            }
        },
        methods: {
            close() {
                this.$router.back();
            },
            openModal(table_name, note_id, note_title) {
                this.modals.addNote = true;
                this.modals.note_id = note_id;
                this.modals.note_title = note_title;
                this.modals.table_name = table_name;

                axios.get(apiGatewayDomain + 'financial_proposal/' + table_name + '/' + note_id ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.modals.note = response.data.data[0].remark;
                    }
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Show Note")
                });

                this.resetModal();
            },
            closeModal() {
                this.modals.addNote = false;
                this.resetModal()
            },
            resetModal() {
                this.modals.note = null;
            },
            getCustomerInfo()
            {
                axios.get(apiGatewayDomain + 'financial_proposal/financial_proposal/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.customers = response.data.data[0]
                    }
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Show Customer Income")
                });
            },
            getCustomerIncomeData() {
                axios.get(apiGatewayDomain + 'financial_proposal/get_customer_income/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.cashIncomesData = response.data
                        let cashIncomesData = this.cashIncomesData;
                        let calculatedGrossIncome = 0;
                        Object.values(cashIncomesData.plus_info).forEach((data) => {
                            if(data.admin_value == null)
                            {
                                calculatedGrossIncome += data.customer_value;
                            }
                            else
                            {
                                calculatedGrossIncome += data.admin_value;
                            }
                        });
                        // check if gross income admin value is null or not
                        if(this.cashIncomesData.gross_income.admin_value != null)
                        {
                            if((this.cashIncomesData.gross_income.admin_value != this.cashIncomesData.gross_income.customer_value 
                            && this.cashIncomesData.gross_income.admin_value != calculatedGrossIncome) || this.cashIncomesData.gross_income.admin_value == this.cashIncomesData.customer_value)
                            {
                                this.inputGrossIncome = true;
                                this.getNetFlow();
                            }
                        }
                    }
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Show Customer Income")
                });
            },
            updateTotalIncomeAdminValue: debounce(function (customer_income_id, admin_value) {
                const postData = {
                    admin_value : admin_value,
                }
                
                axios.put(apiGatewayDomain + 'financial_proposal/customer_income/' + customer_income_id, postData, { headers: getHeader() })
                .then(response => {
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Error Saving Total Income Admin Value") 
                });
            },1500),
            autoUpdateGrossIncomeAdminValue: debounce(function (customer_income_id, admin_value) {
                const postData = {
                    admin_value : admin_value,
                }
                
                axios.put(apiGatewayDomain + 'financial_proposal/customer_income/' + customer_income_id, postData, { headers: getHeader() })
                .then(response => {
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Error Saving Auto Calculated Gross Income Admin Value") 
                });
            },1000),
            updateAdminValue: debounce(function (table_name, customer_income_id, admin_value) {
                const postData = {
                    admin_value : admin_value,
                }
                axios.put(apiGatewayDomain + 'financial_proposal/' + table_name + '/' + customer_income_id, postData, { headers: getHeader() })
                .then(response => {
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Error Saving Admin Value") 
                });
            }, 1000),
            updateNote() {
                const postData = {
                    remark : this.modals.note,
                }
                axios.put(apiGatewayDomain + 'financial_proposal/' + this.modals.table_name + '/' + this.modals.note_id, postData, { headers: getHeader() })
                .then(response => {
                    this.$notify({
                        message:
                            '<b>Note Successfully Updated.',
                        timeout: 10000,
                        icon: 'ni ni-bell-55',
                        type: 'default',
                    });
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Error Saving Note Value") 
                });
            },
            getCustomerFixedExpenseData() {
                axios.get(apiGatewayDomain + 'financial_proposal/get_customer_liability/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.fixedExpensesData = response.data
                    }
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Show Customer Fixed Expense")
                });
            },
            updateFixedExpenseAdminValue: debounce(function(customer_liability_id, curr_installment) {
                const postData = {
                    admin_curr_installment : curr_installment,
                }
                axios.put(apiGatewayDomain + 'financial_proposal/customer_liability/' + customer_liability_id, postData, { headers: getHeader() })
                .then(response => {
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Error Saving Admin Value") 
                });
            },1000),
            getCustomerVariableExpenseData() {
                axios.get(apiGatewayDomain + 'financial_proposal/get_customer_expense/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.variableExpensesData = response.data
                    }
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Show Customer Variable Expense")
                });
            },
            resetGrossIncomeAdminValue() {
                this.inputGrossIncome = false;
                this.getNetFlow();
            },
            manualUpdateGrossIncomeAdminValue(customer_income_id, admin_value) {
                this.inputGrossIncome = true;

                this.updateAdminValue('customer_income', customer_income_id, admin_value)

                this.getNetFlow();
            },
            getGrossIncome() {
                let grossIncome = {
                    admin_annual: 0,
                    admin_month: 0,
                }
                let manualInput = parseFloat(this.incomeAdminValue.gross_income.admin_month);
                Object.values(this.incomeAdminValue.plus_info).forEach((data) => {
                    if(isNaN(data.admin_month))
                    {
                        data.admin_month = 0;
                        data.admin_annual = 0;
                    }

                    grossIncome.admin_annual += data.admin_annual;
                    grossIncome.admin_month += data.admin_month;
                }); 

                this.autoGrossIncome = {...grossIncome};
            
                if(this.inputGrossIncome)
                {
                    grossIncome.admin_annual = manualInput * 12;
                    grossIncome.admin_month = manualInput;
                }
                
                if(grossIncome.admin_month == 0)
                {
                    if(this.cashIncomesData.gross_income)
                    {
                        grossIncome.admin_month = this.cashIncomesData.gross_income.customer_value;
                        grossIncome.admin_annual = this.cashIncomesData.gross_income.customer_value * 12;
                    }
                }
                
                // set gross income admin month value to 2 decimal place
                grossIncome.admin_month = parseFloat(grossIncome.admin_month.toFixed(2));

                this.incomeAdminValue.gross_income = grossIncome;
            },
            getInflow() {
                let totalIncomeAdminValue = {
                    plus_info: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    minus_info: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    total_inflow: {
                        total_month: 0,
                        total_annual: 0,
                    },
                };

                this.getGrossIncome();

                /** get total plus info */
                if(isNaN(this.incomeAdminValue.bonus_income.admin_month))
                {
                    this.incomeAdminValue.bonus_income.admin_month = 0;
                    this.incomeAdminValue.bonus_income.admin_annual = 0;
                }

                totalIncomeAdminValue.plus_info.total_month += this.incomeAdminValue.bonus_income.admin_month;
                totalIncomeAdminValue.plus_info.total_month += this.incomeAdminValue.total_rental_income.admin_month;
                totalIncomeAdminValue.plus_info.total_annual = totalIncomeAdminValue.plus_info.total_month * 12;
                
                /** get total minus info */
                Object.values(this.incomeAdminValue.minus_info).forEach((data) => {
                    if(isNaN(data.admin_month))
                    {
                        data.admin_month = 0;
                    }
                    totalIncomeAdminValue.minus_info.total_month += data.admin_month;
                });
                totalIncomeAdminValue.minus_info.total_annual = totalIncomeAdminValue.minus_info.total_month * 12;

                totalIncomeAdminValue.total_inflow.total_annual = this.incomeAdminValue.gross_income.admin_annual + totalIncomeAdminValue.plus_info.total_annual - totalIncomeAdminValue.minus_info.total_annual;
                totalIncomeAdminValue.total_inflow.total_month = this.incomeAdminValue.gross_income.admin_month + totalIncomeAdminValue.plus_info.total_month - totalIncomeAdminValue.minus_info.total_month;

                this.totalIncomeAdminValue = totalIncomeAdminValue;
            },
            getOutflow() {
                let totalExpenseAdminValue = {
                    fixed: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    variable: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    total_outflow: {
                        total_month: 0,
                        total_annual: 0,
                    }
                };
                Object.keys(this.expenseAdminValue).forEach((key) => {
                    Object.values(this.expenseAdminValue[key]).forEach((data) => {
                        if(isNaN(data.admin_annual))
                        {
                            data.admin_annual = 0;
                        }

                        if(isNaN(data.admin_month))
                        {
                            data.admin_month = 0;
                        }
                        totalExpenseAdminValue[key].total_annual += data.admin_annual;
                        totalExpenseAdminValue[key].total_month += data.admin_month;
                    });   
                });

                totalExpenseAdminValue.total_outflow.total_annual = totalExpenseAdminValue.fixed.total_annual + totalExpenseAdminValue.variable.total_annual;
                totalExpenseAdminValue.total_outflow.total_month = totalExpenseAdminValue.fixed.total_month + totalExpenseAdminValue.variable.total_month;

                this.totalExpenseAdminValue = totalExpenseAdminValue;
            },
            getNetFlow() {
                this.getInflow();
                this.getOutflow();

                let totalNetFlow = {
                    total_month: 0,
                    total_annual: 0,
                };
                let actualTotalNetFlow = 0;

                totalNetFlow.total_month = this.totalIncomeAdminValue.total_inflow.total_month - this.totalExpenseAdminValue.total_outflow.total_month;
                totalNetFlow.total_annual = this.totalIncomeAdminValue.total_inflow.total_annual - this.totalExpenseAdminValue.total_outflow.total_annual;
                this.totalNetFlow = totalNetFlow;
                
                actualTotalNetFlow = this.totalIncomeAdminValue.total_inflow.total_annual - (this.actualNetflowData.annual_fixed_expense + this.actualNetflowData.annual_variable_expense);
                this.actualNetflowData.annual_total_netflow = actualTotalNetFlow;

                const cashFlowStatementData = {
                    cash_inflow: {...this.totalIncomeAdminValue.total_inflow},
                    cash_outflow: {...this.totalExpenseAdminValue},
                    actual_net_flow: this.actualNetflowData,
                    commitment: this.fixedExpenses.total.total_month_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2}),
                    var_expenses: this.totalExpenseAdminValue.fixed.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})
                };

                this.$emit('cash-flow-statement-data', cashFlowStatementData);
            },
            sendKYCToCustomer() {
                let kyc_link = '';
                if(process.env.DEMO)
                {
                    kyc_link = "https://kyc_demo.fintos.com.my/";
                }
                else
                {
                    kyc_link = "https://kyc.fintos.com.my/";
                }

                window.location.href = kyc_link + "customer/sendCustomersForm/"+this.$route.params.customer_id+"/IM2U/"+this.$route.params.token_kyc+"/"+this.$route.params.proposal_id;
            },
            async addInflowToCustomerAssets(net_inflow) {
                const postData = {
                    financial_proposal_id : this.$route.params.financial_proposal_id,
                    asset_type_id: 1,
                    asset_title: 'saving from net inflow',
                    admin_value: net_inflow,
                }
                const str = JSON.stringify(postData);

                await axios.post(apiGatewayDomain + 'financial_proposal/customer_asset', postData ,{ headers: getHeader() })
                .then ( response => {
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Create Customer Asset")
                });
            },
        }
    };
</script>
<style scoped>
table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

td , th {
    border: 1px solid #dddddd;
    text-align: center;
    /* height: 10px; */
    /* width: 20%; */
}

td:first-child {
    text-align: left;
    padding-left: 8px;
}

th {
    background-color: #525f7f;
    font-size: large;
    width: 20%;
}

.button-right {
    padding-right: 0;
}
</style>
<style>
#admin-value {
    text-align:center;
    font-size:medium;
}
</style>